import { Injectable } from '@angular/core';

import { IBetslipState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { ITypeBetslip } from '../../../../bet-generation/models';
import { BetslipError } from '../../../errors/betslip-error';
import { BetslipComboBetValidationComposerService } from './composers/betslip-combo-bet-validation-composer.service';
import { BetslipEditBetValidationComposerService } from './composers/betslip-edit-bet-validation-composer.service';
import { BetslipSingleBetValidationComposerService } from './composers/betslip-single-bet-validation-composer.service';
import { BetslipSystemBetValidationComposerService } from './composers/betslip-system-bet-validation-composer.service';
import { BetslipTeaserBetValidationComposerService } from './composers/betslip-teaser-bet-validation-composer.service';

@Injectable()
export class BetslipTypeRestrictedValidationService {
    constructor(
        private singleBetValidation: BetslipSingleBetValidationComposerService,
        private comboBetValidation: BetslipComboBetValidationComposerService,
        private systemBetValidation: BetslipSystemBetValidationComposerService,
        private teaserBetValidation: BetslipTeaserBetValidationComposerService,
        private editBetValidation: BetslipEditBetValidationComposerService,
    ) {}

    validate(typeBetslip: ITypeBetslip, state: IBetslipState): BetslipError[] {
        switch (typeBetslip.type) {
            case BetslipType.Single:
                return this.singleBetValidation.validate(typeBetslip, state);

            case BetslipType.Combo:
                return this.comboBetValidation.validate(typeBetslip, state);

            case BetslipType.System:
                return this.systemBetValidation.validate(typeBetslip, state);

            case BetslipType.Teaser:
                return this.teaserBetValidation.validate(typeBetslip, state);

            case BetslipType.EditBet:
                return this.editBetValidation.validate(typeBetslip, state);

            default:
                return [];
        }
    }
}
